// MatchMedia Docs: https://greensock.com/docs/v3/GSAP/gsap.matchMedia()
// ScrollTrigger Docs: https://greensock.com/docs/v3/Plugins/ScrollTrigger


import SplitType from "split-type";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

let mm = gsap.matchMedia(),
    breakPoint = 1024;

    mm.add({
        // set up any number of arbitrarily-named conditions. The function below will be called when ANY of them match.
        isDesktop: `(min-width: ${breakPoint}px)`,
        isMobile: `(max-width: ${breakPoint - 1}px)`
    }, (context) => {
        // context.conditions has a boolean property for each condition defined above indicating if it's matched or not.
        let { isDesktop, isMobile } = context.conditions;

        let t1 = gsap.timeline({
            scrollTrigger:{
                trigger: '.intro-wrapper',
                pin: true,
                start: "top top",
                end: "bottom top",
                scrub: .5
            }
        });

        t1.to('.intro-scroll', {
            opacity: 0,
            y: 30,
            duration: .01
        });

        t1.to('.site-header .logo', {
            opacity: 0,
            duration: .01
        },0);

        t1.to('.logo-25',{
            rotation: 90,
            xPercent: () => {
                return isDesktop ? -54.12 : -54.2
            },
            ease: "none",
        },0);

        t1.to('.logo-25',{
            width: isDesktop ? 1755 : 1000,
            y: () => {
                let svg = isDesktop ? 1755 : 1000;
                let sectionHeight = window.innerHeight < 805 ? 850 : window.innerHeight;
                let diviser = isDesktop ? 2.05 : .6;
                
                //offset the positon of the svg based on the svg width which is rotated and the window height
                return -(svg - sectionHeight)/diviser
            },
            ease: "none"
        });

        return () => { 
            // optionally return a cleanup function that will be called when the media query no longer matches
        }
    }); 


    //global reveal triggers
    //When trigger class is 200px from the bottom in view toggle the "revealed" class
    //what happens when that class is added is up to the css
    const reveal = gsap.utils.toArray('.js-trigger-effect');
    reveal.forEach(reveal => {

        // Content Reveal Animation
        ScrollTrigger.create({
            start: "top bottom-=15%", //100px from the bottom
            trigger: reveal,
            onEnter: ({ progress, direction, isActive }) => reveal.classList.add('animated'),
            //onLeaveBack: ({progress, direction, isActive}) => reveal.classList.remove('animated'),
            //markers: {startColor: "blue", endColor: "blue", fontSize: "18px", fontWeight: "bold", indent: 20}
        });

    });

    const arrows = document.querySelectorAll('.js-tracker-arrow .arrow');
    const timelineArrow = gsap.utils.toArray(arrows);
    timelineArrow.forEach(arrow => {

        //This causes the wiggle in chrome and FF so its not better
        // gsap.to(arrow, {
        //     scrollTrigger: {
        //         trigger: arrow.parentElement,
        //         start: "top center+=35%",
        //         end: () => "+=" + arrow.parentElement.offsetHeight,
        //         scrub: true,
        //         markers: true
        //     },
        //     top: "100%",
        //     ease: "none",
        // });

        ScrollTrigger.create({
            trigger: arrow,
            pin: true,
            //pinType: "transform",
            //pinnedContainer: arrow.parentElement,
            start: "top center+=35%",
            end: () => "+=" + arrow.parentElement.offsetHeight,
            scrub: 1,
            anticipatePin: 1
            //markers: true
        });

    });

    const fancyText = document.querySelectorAll('.js-animate-text');
    const fancyTextArr = gsap.utils.toArray(fancyText);
    fancyTextArr.forEach(element => {

        let text = new SplitType(element, { types: 'words, chars' });
        let chars = text.chars;
        
        gsap.to(chars, {
            scrollTrigger: {
                trigger: element,
                start: "top bottom-=200px"
            },
            duration: .5,
            y: 0,
            ease: "power2.out",
            stagger: {
                each: .003,
                //amount: 1,
                from: "start",
                ease: "none",
            },
            
        });

    });

    gsap.from('.client-logo', {
        scrollTrigger: {
            trigger: '.client-logo',
            start: "top bottom-=200px"
        },
        duration: .5,
        y: 40,
        scale: 0.1,
        opacity: 0,
        ease: "power2.out",
        stagger: {
            amount: .75
        }
    });

    //map pins
    gsap.from('.section-map__points .point', {
        scrollTrigger: {
            trigger: '.section-map__points',
            start: "top top+=10%",
            end: "bottom top",
            //toggleActions: "restart none none reset",
            //markers: {startColor: "blue", endColor: "blue", fontSize: "16px", fontWeight: "bold", indent: 5}
        },
        duration: .5,
        opacity: 0,
        ease: "power2.out",
        stagger: {
            amount: .75
        }
    });
